import { Component, inject } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';

import { FontIconComponent } from '@camelot/icons';
import { CamTranslationService } from '@camelot/translation';

import { SwitchLanguageComponent } from '../switch-language.component';

@Component({
  selector: 'cam-switch-language-cta',
  templateUrl: './switch-language-cta.component.html',
  styleUrls: ['./switch-language-cta.component.scss'],
  imports: [FontIconComponent, MatMenuModule, SwitchLanguageComponent],
})
export class SwitchLanguageCtaComponent {
  readonly translateService = inject(CamTranslationService);

  public activeLanguage = this.translateService.getLanguage();
}
